import { QuoteOption } from './../../../models/quote.model';
import { ErrorResponse } from 'src/app/models/error.model';
import { UtilsService } from './../../../services/utils.service';
import { PaymentInformation } from './../../../models/payment-information.model';
import { PaymentMethod } from '../../../models/payments.model';
import { Component, Input, OnInit, Output, EventEmitter, } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Document } from 'src/app/models/document.model';
import { ID } from '../../../models/ID.model';
import { DataTableColumn } from '../data-table/data-table.component';
import { PaymentOptionType } from '../../../models/quote.model';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';

export interface PaymentConfig {
    bin?: string;
    comprobantes: ID[];
    medio?: PaymentMethod;
    opcion?: QuoteOption;
    token?: string;
    montoPagado?: number;
}

@Component({
    selector: 'app-payment-form',
    templateUrl: './payment-form.component.html',
    styleUrls: ['./payment-form.component.scss']
})
export class PaymentFormComponent implements OnInit {

    @Output()
    paymentChange = new EventEmitter<Partial<PaymentConfig>>();

    @Input()
    payment?: PaymentConfig;

    @Input()
    paymentInformation: PaymentInformation;

    @Input()
    uploadPaymentProofFn: (file: File) => Promise<Document>;

    paymentOptionValue: PaymentOptionType;
    set paymentOption(newValue: PaymentOptionType) {
        this.paymentOptionValue = newValue;
        if (newValue === 'EFECTIVO') {
            this.updatePayment({ medio: 'EFECTIVO', comprobantes: [] });
        } else if (newValue === 'TRANSFERENCIA') {
            this.updatePayment({ medio: 'TRANSFERENCIA', comprobantes: [], opcion: this.getQuoteOptions('TRANSFERENCIA')[0] });
        } else {
            this.updatePayment({ medio: null, opcion: undefined, comprobantes: [], montoPagado: null });
        }
    }
    get paymentOption() {
        return this.paymentOptionValue;
    }

    transferForm = new UntypedFormGroup({
        montoPagado: new UntypedFormControl(undefined, [Validators.required])
    });

    cashForm = new UntypedFormGroup({
        montoPagado: new UntypedFormControl(undefined, [Validators.required])
    });

    paymentOptionsTableColumns: DataTableColumn[] = [
        { name: 'Cuotas', prop: 'cuotas' },
        { name: 'Monto por cuota', prop: 'montoPorCuota', type: 'money' },
        { name: 'Monto total', prop: 'montoTotal', type: 'money' },
    ];

    user?: User;

    constructor(
        public utilsService: UtilsService,
        private authService: AuthService,
    ) { }

    ngOnInit(): void {
        this.user = this.authService.getUser();
        this.transferForm.controls.montoPagado.valueChanges.subscribe(newValue => {
            this.updatePayment({ montoPagado: newValue });
        });
        this.cashForm.controls.montoPagado.valueChanges.subscribe(newValue => {
            this.updatePayment({ montoPagado: newValue });
        });
    }

    updatePayment(changes: Partial<PaymentConfig>) {
        this.paymentChange.emit(changes);
    }

    getSectionTitle() {
        switch (this.paymentOption) {
            case 'CREDITO':
                return 'Tarjeta de crédito';
            case 'DEBITO':
                return 'Tarjeta de débito';
            case 'EFECTIVO':
                return 'Efectivo';
            case 'TRANSFERENCIA':
                return 'Transferencia';
            default:
                return '';
        }
    }

    getSectionDescription() {
        switch (this.paymentOption) {
            case 'CREDITO':
            case 'DEBITO':
                return 'Verifique el monto y la cantidad de cuotas antes de generar el link de pago.';
            case 'EFECTIVO':
                return 'Por favor ingrese el monto que se pagará en efectivo.';
            case 'TRANSFERENCIA':
                return 'Por favor realice la transferencia a la siguiente cuenta, una vez completada suba el o los comprobantes correspondientes.';
            default:
                return '';
        }
    }

    uploadPaymentProofs(event: any) {
        const files = Array.from(event.target.files) as File[];
        this.updatePayment({ comprobantes: [] });
        files.forEach(file => {
            this.uploadPaymentProofFn(file).then(document => {
                this.updatePayment({ comprobantes: [...this.payment.comprobantes, document.id] });
            }, (error: ErrorResponse) => this.utilsService.alert('Error al subir comprobante', error.error?.descripcion));
        });
    }

    isValid() {
        if (this.paymentOption === 'TRANSFERENCIA') {
            this.transferForm.markAllAsTouched();
            return this.transferForm.valid && !!this.payment?.comprobantes?.length;
        } else if (this.paymentOption === 'CREDITO' || this.paymentOption === 'DEBITO') {
            return !!this.payment?.opcion;
        } else if (this.paymentOption === 'EFECTIVO') {
            this.cashForm.markAllAsTouched();
            return this.cashForm.valid;
        } else {
            return false;
        }
    }

    onPaymentOptionChange(selected: QuoteOption[]) {
        this.updatePayment({ opcion: selected[0], medio: 'MERCADO_PAGO', montoPagado: selected[0]?.montoTotal });
    }

    getQuoteOptions(paymentOption: PaymentOptionType) {
        return this.paymentInformation.cotizacion.opciones.filter(opcion => opcion.tipo === paymentOption);
    }
}
